import { useEffect, useState } from "react";
import { api } from "./api";

export const useFetch = (url, deps = []) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let live = true;
    if (!url) return () => { live = false; };
    api.get(url).then((r) => { if (live) setData(r.data); }).catch((e) => { if (live) { setError(e); setData(null); } });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  return { data, error, loading: data === null && !error };
};
